import { Link } from "react-router-dom";
import { ArrowRight, MessageCircle } from "lucide-react";

const AppSection = () => (
  <>
    {/* Sobre o aplicativo */}
    <section id="consultor-ia" className="py-16 sm:py-24 bg-card/30">
      <div className="container mx-auto px-5 sm:px-4">
        <div className="max-w-4xl mx-auto text-center">
          <div className="w-14 h-14 sm:w-20 sm:h-20 mx-auto mb-6 rounded-2xl bg-primary/10 flex items-center justify-center">
            <MessageCircle className="w-7 h-7 sm:w-10 sm:h-10 text-primary" />
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold mb-4">
            O aplicativo das <span className="text-gradient-green">12 Personas</span> de estilo
          </h2>
          <p className="text-sm sm:text-xl text-muted-foreground mb-6 text-left sm:text-center leading-relaxed">
            No aplicativo você poderá conversar com nosso consultor de estilo, criado por Inteligência Artificial, o nome dele é Leo. <br />
            Leo te conhecerá muito bem, porque ele sempre terá o resultado do seu teste de estilo express em mãos.
            <br /> Com base no seu estilo o Leo poderá te sugerir melhores looks para qualquer ocasião: reuniões profissionais,jantares, festas, entrevistas,encontros amorosos, viagens, ou qualquer evento que você imaginar.
            <br /> O Leo enviará uma imagem sua, com seu corpo e seu rosto, vestindo looks autênticos e interessantes.{" "}
            <br />
            Você ainda pode enviar para o para o Leo fotos de peças do seu guarda-roupas, fotos de peças que você tirou dentro de um provador ou mesmo fotos de peças de famosos que você acompanha nas redes. Depois disso o Leo vai te enviar uma foto real sua vestindo qualquer uma dessas peças. Você poderá baixar essas imagens e usar como quiser.
            <br />
            Quando você estiver fazendo sua mala para viajar é só fotografar as peças e o Leo irá enviar imagens suas com os looks para cada dia da sua viagem! <br /> Você pode usar o Leo de diversas formas, basta usar sua imaginação. E o mais legal, o Leo nunca esquece quem é você. Ele terá sempre seu teste de estilo em mãos, saberá suas preferências pessoais. O Leo está sempre aprendendo algo sobre você!
            <br /> Agora se você quiser que ele te conheça profundamente você pode fazer seu grande teste das 12 Personas de Estilo, aí o Leo terá sempre em mãos o seu Mapa de Estilo, que é uma análise profunda sobre do seu estilo.
          </p>

          <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-4">
            <Link to="/teste" className="btn-elegant inline-flex items-center justify-center gap-2 text-sm sm:text-base">
              Saber mais sobre o aplicativo
              <ArrowRight className="w-5 h-5 shrink-0" />
            </Link>
          </div>
          <p className="mt-4 text-sm sm:text-base text-left sm:text-center leading-relaxed">
            Importante: O aplicativo é parte integrante da assinatura do nosso portal da 12 Personas de Estilo. Sendo membro do nosso portal por assinatura você tem direito a todos os produtos do portal: ebooks, testes, cursos, atualizações no período da assinatura e ainda poderá usar nosso aplicativo
          </p>
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-4 mt-4">
            <Link to="/teste" className="btn-elegant inline-flex items-center justify-center gap-2 text-xs sm:text-base text-center">
              QUERO SER MEMBRO DO PORTAL DAS 12 PERSONAS
              <ArrowRight className="w-5 h-5 shrink-0" />
            </Link>
          </div>
        </div>
      </div>
    </section>

    {/* Consultor */}
    <section className="py-16 sm:py-24 bg-card/30">
      <div className="container mx-auto px-5 sm:px-4">
        <div className="max-w-4xl mx-auto text-center">
          <div className="w-14 h-14 sm:w-20 sm:h-20 mx-auto mb-6 rounded-2xl bg-primary/10 flex items-center justify-center">
            <MessageCircle className="w-7 h-7 sm:w-10 sm:h-10 text-primary" />
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold mb-4">
            O aplicativo das <span className="text-gradient-green">12 Personas</span> para consultores de imagem
          </h2>
          <p className="text-sm sm:text-xl text-muted-foreground mb-6 leading-relaxed">
            Você é consultor de imagem? Entre em contato para conhecer nosso aplicativo na versão para consultores com condições especiais
          </p>
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-4">
            <Link to="/consultores" className="btn-elegant inline-flex items-center justify-center gap-2">
              SAIBA MAIS
              <ArrowRight className="w-5 h-5 shrink-0" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  </>
);

export default AppSection;
